/* eslint-disable max-len */
/* eslint-disable react/jsx-child-element-spacing */
import 'src/styles/Custom/cookielaw.css'

import { Button, Drawer, Grid, Link, Stack, Typography } from '@mui/material'

import type { BasicOrganisation } from 'src/models/Organisation'

type Props = {
  open: boolean
  close: () => void
  gdprTracking: boolean
  openPreferenceCenter: () => void
  acceptAll: () => void
  declineAll: () => void
  organisation: BasicOrganisation | null
}

const PrivacyBanner = (props: Props) => {
  const acceptAllCookies = () => {
    props.acceptAll()
    props.close()
  }

  const declineAllCookies = () => {
    props.declineAll()
    props.close()
  }

  const customizeCookies = () => {
    props.openPreferenceCenter()
    props.close()
  }

  return (
    <Drawer
      anchor='bottom'
      onClose={props.close}
      open={props.open}
    >
      <Grid container minHeight={100} padding={2} spacing={2}>

        <Grid item lg={8} md={8} sm={12} xl={8} xs={12}>
          <Stack direction='column' width={1}>
            <Typography variant='h4'>
              Privacy Notice
            </Typography>
            <Typography variant='body2'>
              On behalf of
              <b>
                {` ${props.organisation?.name}, `}
              </b>
              {' Releese would like permission to store cookies and to track marketing performance in accordance with our '}
              <Link
                href='https://releese.io/legal/privacy-policy/'
                target='_blank'
              >
                Privacy Policy
              </Link>
              {' and our '}
              <Link
                href='https://releese.io/legal/cookie-policy/'
                target='_blank'
              >
                Cookie Policy
              </Link>
              .
            </Typography>
          </Stack>
        </Grid>

        <Grid item lg={4} md={4} sm={12} xl={4} xs={12}>
          <Stack alignItems='center' direction='row' height={1} justifyContent='center' spacing={1} width={1}>
            {props.gdprTracking &&
            <Button color='error' onClick={declineAllCookies} rounded variant='text'>
              Reject all
            </Button>}
            <Button color='primary' onClick={customizeCookies} rounded variant='outlined'>
              Customize
            </Button>
            <Button color='primary' onClick={acceptAllCookies} rounded sx={{ minWidth: 130 }}>
              Accept all
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Drawer>
  )
}

export default PrivacyBanner
